<template>
    <div :class="buttonCss" @click="redirectToQuiz">
        <span class="whitespace-nowrap" v-html="buttonTitle" />
    </div>
</template>
<script>
export default {
    name: "StudentTakeQuizButton",
    props: {
        buttonTitle: {
            type: String,
            default: "Take Quiz",
        },
        buttonCss: {
            type: String,
            default: "btn btn-primary",
        },
        quizType: {
            type: String,
            default: "random",
        },
        focusArea: {
            type: Object,
            default: null,
        },
    },
    methods: {
        redirectToQuiz() {
            let params = { quiz_type: this.quizType };

            if (this.focusArea) {
                params.focus_area_id = this.focusArea.id;
                params.focus_area_url_title = this.focusArea.url_title;
            }

            this.$inertia.get(route("student.quiz.start", params));
        },
    },
};
</script>
